import ProductVariantDataHandler from 'PyzShopUi/scripts/product-detail-page/includes/productVariantData';

export const redirectToConcrete = (concreteId: number, sku?: string) => {
    let productSku = sku;
    
    // Fallback to DOM if SKU not provided (for backward compatibility)
    if (!productSku) {
        const productVariantData = ProductVariantDataHandler.init();
        productSku = productVariantData[concreteId]?.sku;
    }
    
    if (!productSku) {
        console.error('Could not find SKU for concrete ID:', concreteId);
        return;
    }

    const currentURL = new URL(window.location.href);
    
    // Preserve existing filter_bike_id parameter (important for dropdown to work after reload)
    const existingBikeId = currentURL.searchParams.get('filter_bike_id');
    
    // Set the filter_article_number parameter
    currentURL.searchParams.set('filter_article_number', productSku);
    
    // Restore filter_bike_id if it existed (preserve bike selection)
    if (existingBikeId) {
        currentURL.searchParams.set('filter_bike_id', existingBikeId);
    }

    // since the onChange handler is called on init, without this if clause
    // we'd end in an infinity loop of reloads
    if (window.location.href !== currentURL.href) {
        // we should replace the history in the url to deal with the issue of back button on mobile browser
        history.replaceState({ path: currentURL.toString() }, document.title, currentURL.toString());
        window.location.href = currentURL.href;
    }
}
